export const PRICE_PIANO_MODEL = "Price_piano_model";
export const PRICE_SPECIFIC_MODEL = "Price_specific_model";